import { get } from 'lodash';
import { defaultTextColor } from '../../utils/defaults';
import { getTextAlign } from '../../utils/get-text-align';
export var getText = function (_a) {
    var _b;
    var region = _a.region, css = _a.css, isRtl = _a.isRtl, cssClass = _a.cssClass, componentStylePath = _a.componentStylePath, _c = _a.bolden, bolden = _c === void 0 ? false : _c;
    var regionTextStyle = get(region, componentStylePath, {});
    var textStyle = css[cssClass];
    var textAlign = getTextAlign(regionTextStyle.align, isRtl ? 'right' : 'left');
    return {
        align: textAlign,
        color: regionTextStyle.color || textStyle.color || defaultTextColor,
        fontFamily: regionTextStyle.fontFamily || textStyle.fontFamily,
        fontSize: regionTextStyle.fontSize || textStyle.fontSize,
        fontStyle: regionTextStyle.fontStyle || textStyle.fontStyle,
        fontWeight: (_b = regionTextStyle.fontWeight) !== null && _b !== void 0 ? _b : (bolden ? 'bold' : textStyle.fontWeight),
        textDecoration: regionTextStyle.textDecoration || textStyle.textDecoration,
        lineHeight: regionTextStyle.lineHeight || textStyle.lineHeight,
    };
};
//# sourceMappingURL=get-text.js.map